// extracted by mini-css-extract-plugin
export var modalFooter = "_re-0";